import { Theme } from "@material-ui/core";

export const getSopStatusColor = (status: SopStatus, theme: Theme): string => {
  switch (status) {
    case "Locked":
      return theme.hv.palette.atmosphere.atmo5;
    case "Unlocked":
      return theme.hv.palette.accent.acce1;
    case "InProgress":
      return "#2E5CA1";
    case "Completed":
      return "#669A1D";
    default:
      return theme.hv.palette.accent.acce1;
  }
};
